export const queryKeys = {
  DISCOUNT_CONFIG_PREPAYMENT_CALCULATE: 'DISCOUNT_CONFIG_PREPAYMENT_CALCULATE'
};
